var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../../di";
import { PromotionScheme } from "../PromotionScheme";
import { PromotionInstanceAvailabilityService } from "./PromotionInstanceAvailabilityService";
let PromotionSchemeAvailabilityService = class PromotionSchemeAvailabilityService {
    constructor(promotionScheme, promotionInstanceAvailabilityService) {
        this.promotionScheme = promotionScheme;
        this.promotionInstanceAvailabilityService = promotionInstanceAvailabilityService;
        makeAutoObservable(this);
    }
    get possiblePromotionInstances() {
        return this.promotionScheme.promotionInstances.filter((promotionInstance) => this.promotionInstanceAvailabilityService.availability(promotionInstance).isAvailable.isPossible);
    }
    get activePossiblePromotionInstances() {
        return this.possiblePromotionInstances.filter((promotionInstance) => promotionInstance.active);
    }
    get doesAnyActivePromotionRequireMarketingConsents() {
        return this.activePossiblePromotionInstances.objects.some((promotionInstance) => promotionInstance.promotionType.requiresMarketing);
    }
};
PromotionSchemeAvailabilityService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof PromotionScheme !== "undefined" && PromotionScheme) === "function" ? _a : Object, typeof (_b = typeof PromotionInstanceAvailabilityService !== "undefined" && PromotionInstanceAvailabilityService) === "function" ? _b : Object])
], PromotionSchemeAvailabilityService);
export { PromotionSchemeAvailabilityService };
